import axios from 'axios';
import { getStoredDb } from '../utils/DbContext';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  config.headers['x-db-name'] = getStoredDb();
  return config;
});

export default api;
